import { projectClient } from '../../client/client';

export const secret = {
  list: projectClient('/secret').get,
  create: projectClient('/secret').post,
  get: projectClient('/secret/{name}').get,
  delete: projectClient('/secret/{name}').delete,
};
